import React from 'react'
import styles from './ModalGPT.module.scss'
import {TriangleErrorIcon} from "../../helpers/icons";
import {PositionLabel} from "../../Viewer/path/PositionLabel";
import {CardTextBlock} from "../cards/CardTextBlock";


const HandHistory = ({trace, players, ante, isHero}) => {

    let isPreflopShown = false
    let isFlop = false
    let isTurn = false
    let isRiver = false
    let heroErrorShown = false

    // get hero position
    let heroIndex = isHero.indexOf(true)

    // define initial pot value
    let currentPot = 1.5 + ante * players.length

    // boards
    const flopBoard = trace.find(item => item['type'] === 'flop') ? trace.find(item => item['type'] === 'flop')['real_action'] : null;
    const turnBoard = trace.find(item => item['type'] === 'turn') ? trace.find(item => item['type'] === 'turn')['real_action'] : null;
    const riverBoard = trace.find(item => item['type'] === 'river') ? trace.find(item => item['type'] === 'river')['real_action'] : null;

    return (

        <div className={styles.handHistoryWrapper}>

            {
                ante && ante > 0 ?
                    <div className={styles.traceRow}>
                        <div className={styles.traceRowLabel}>Ante</div>
                        <div className={styles.traceActionRow}>{ante} bb</div>
                    </div>
                    : null
            }
            <div className={styles.traceRow}>
                <div className={styles.traceRowLabel}>Blinds</div>
                <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                    <div className={styles.traceActionRow}>
                        <PositionLabel player="SB"/>Posts 0.5 bb
                    </div>
                    <div className={styles.traceActionRow}>
                        <PositionLabel player="BB"/>Posts 1.0 bb
                    </div>
                </div>
            </div>

            {/* PREFLOP */}
            <div className={styles.traceRow}>
                <div className={styles.traceRowLabel}>Preflop</div>
                <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                    {trace.map((item) => {

                        // skipping stack element
                        if (item['type'] === 'stack' || item['choose'] === -1 || heroErrorShown || isFlop) {
                            return false
                        }

                        // stop executing map function
                        if (item['player'] === heroIndex) {
                            if (item['is_played'] && item['actions_played'][item['choose']] < 0.02) {
                                heroErrorShown = true
                            }
                        }

                        // reassign pot
                        currentPot = item['pot'] ? item['pot'] : currentPot

                        // reassign flop
                        isFlop = item['type'] === 'flop' ? true : isFlop

                        return (
                            !isFlop &&
                            <div>
                                <div className={styles.traceActionRow}>
                                    {
                                        <>
                                            <PositionLabel player={players[item['player']]}/>
                                            {item['actions'][item['choose']]}
                                            {item['actions'][item['choose']].startsWith('Raise') ? ' bb' : null}
                                            {item['actions'][item['choose']].startsWith('Bet') ? ' bb' : null}
                                            {heroErrorShown ? <TriangleErrorIcon/> : null}
                                        </>
                                    }
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            {/* FLOP */}
            {flopBoard && !heroErrorShown &&
                <div className={styles.traceRow}>
                    <div className={styles.traceRowLabel}>
                        <div>Flop</div>
                        <div style={{height: 25, width: 81, marginTop: 10}}>
                            <CardTextBlock cards={flopBoard} isSquare isFullWidth/>
                        </div>
                        <div>{currentPot} bb</div>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                        {trace.map((item) => {

                            // reassign flop
                            isFlop = item['type'] === 'flop' ? false : isFlop
                            isTurn = item['type'] === 'turn' ? true : isTurn

                            // skipping stack element
                            if (item['type'] === 'stack' || item['type'] === 'flop' ||
                                item['choose'] === -1 || heroErrorShown || isTurn || isFlop) {
                                return false
                            }

                            // stop executing map function
                            if (item['player'] === heroIndex) {
                                if (item['is_played'] && item['actions_played'][item['choose']] < 0.02) {
                                    heroErrorShown = true
                                }
                            }

                            // reassign pot
                            currentPot = item['pot'] ? item['pot'] : currentPot

                            return (
                                !isTurn &&
                                <div>
                                    <div className={styles.traceActionRow}>
                                        {
                                            <>
                                                <PositionLabel player={players[item['player']]}/>
                                                {item['actions'][item['choose']]}
                                                {item['actions'][item['choose']].startsWith('Raise') ? ' bb' : null}
                                                {item['actions'][item['choose']].startsWith('Bet') ? ' bb' : null}
                                                {heroErrorShown ? <TriangleErrorIcon/> : null}
                                            </>
                                        }
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            }

            {/* TURN */}
            {turnBoard && !heroErrorShown &&
                <div className={styles.traceRow}>
                    <div className={styles.traceRowLabel}>
                        <div>Turn</div>
                        <div style={{height: 25, width: 25, marginTop: 10}}>
                            <CardTextBlock cards={turnBoard} isSquare isFullWidth/>
                        </div>
                        <div>{currentPot} bb</div>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                        {trace.map((item) => {

                            // reassign flop
                            isTurn = item['type'] === 'flop' ? false : isTurn
                            isRiver = item['type'] === 'turn' ? true : isRiver

                            // skipping stack element
                            if (item['type'] === 'stack' || item['type'] !== 'action' ||
                                item['choose'] === -1 || heroErrorShown || isTurn || isRiver) {
                                return false
                            }

                            // stop executing map function
                            if (item['player'] === heroIndex) {
                                if (item['is_played'] && item['actions_played'][item['choose']] < 0.02) {
                                    heroErrorShown = true
                                }
                            }

                            // reassign pot
                            currentPot = item['pot'] ? item['pot'] : currentPot

                            return (
                                !isRiver &&
                                <div>
                                    <div className={styles.traceActionRow}>
                                        {
                                            <>
                                                <PositionLabel player={players[item['player']]}/>
                                                {item['actions'][item['choose']]}
                                                {item['actions'][item['choose']].startsWith('Raise') ? ' bb' : null}
                                                {item['actions'][item['choose']].startsWith('Bet') ? ' bb' : null}
                                                {heroErrorShown ? <TriangleErrorIcon/> : null}
                                            </>
                                        }
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            }

            {/* RIVER */}
            {riverBoard && !heroErrorShown &&
                <div className={styles.traceRow}>
                    <div className={styles.traceRowLabel}>
                        <div>River</div>
                        <div style={{height: 25, width: 25, marginTop: 10}}>
                            <CardTextBlock cards={riverBoard} isSquare isFullWidth/>
                        </div>
                        <div>{currentPot} bb</div>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
                        {trace.map((item) => {

                            // reassign flop
                            isRiver = item['type'] === 'river' ? false : isRiver

                            // skipping stack element
                            if (item['type'] === 'stack' || item['type'] !== 'action' ||
                                item['choose'] === -1 || heroErrorShown || isRiver) {
                                return false
                            }

                            // stop executing map function
                            if (item['player'] === heroIndex) {
                                if (item['is_played'] && item['actions_played'][item['choose']] < 0.02) {
                                    heroErrorShown = true
                                }
                            }

                            // reassign pot
                            currentPot = item['pot'] ? item['pot'] : currentPot

                            return (
                                !isRiver &&
                                <div>
                                    <div className={styles.traceActionRow}>
                                        {
                                            <>
                                                <PositionLabel player={players[item['player']]}/>
                                                {item['actions'][item['choose']]}
                                                {item['actions'][item['choose']].startsWith('Raise') ? ' bb' : null}
                                                {item['actions'][item['choose']].startsWith('Bet') ? ' bb' : null}
                                                {heroErrorShown ? <TriangleErrorIcon/> : null}
                                            </>
                                        }
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            }

            {/* {trace.map((item) => { */}

            {/*     // skipping stack element */}
            {/*     if (item['type'] === 'stack' || item['choose'] === -1 || heroErrorShown) { */}
            {/*         return false */}
            {/*     } */}

            {/*     // stop executing map function */}
            {/*     if (item['player'] === heroIndex) { */}
            {/*         if (item['is_played'] && item['actions_played'][item['choose']] < 0.02) { */}
            {/*             heroErrorShown = true */}
            {/*         } */}
            {/*     } */}

            {/*     // reassign pot */}
            {/*     currentPot = item['pot'] ? item['pot'] : currentPot */}

            {/*     return ( */}
            {/*         <div className={styles.traceRow}> */}
            {/*             <div className={styles.traceRowLabel}> */}
            {/*                 <div className={styles.traceStreetName}> */}
            {/*                     {!isPreflopShown ? 'preflop' : null} */}
            {/*                 </div> */}

            {/*                 { */}
            {/*                     isPreflopShown = !isPreflopShown ? true : isPreflopShown */}
            {/*                 } */}
            {/*                 {item['type'] !== 'action' ? */}
            {/*                     <div> */}
            {/*                         <div className={styles.traceStreetName}>{item['type']}</div> */}
            {/*                         <div>{currentPot} bb</div> */}
            {/*                     </div> : null */}
            {/*                 } */}
            {/*             </div> */}
            {/*             <div className={styles.traceActionRow}> */}
            {/*                 { */}
            {/*                     item['type'] === 'action' ? */}
            {/*                         <> */}
            {/*                             <PositionLabel player={players[item['player']]}/> */}
            {/*                             {item['actions'][item['choose']]} */}
            {/*                             {item['actions'][item['choose']].startsWith('Raise') ? ' bb' : null} */}
            {/*                             {item['actions'][item['choose']].startsWith('Bet') ? ' bb' : null} */}
            {/*                             {heroErrorShown ? <TriangleErrorIcon/> : null} */}
            {/*                         </> : */}
            {/*                         <div style={{height: 25, width: item['type'] === 'flop' ? 81 : 25}}> */}
            {/*                             <CardTextBlock cards={item['real_action']} isSquare isFullWidth/> */}
            {/*                         </div> */}
            {/*                 } */}
            {/*             </div> */}

            {/*         </div> */}
            {/*     ) */}
            {/* })} */}

        </div>
    )
}

export default HandHistory
